/**
 * Кастомные скроллбары
 *
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

const defaultSettings = {
  scrollButtons: { enable: true },
  scrollInertia: 150,
  mouseWheel   : {
    preventDefault: true,
    enable        : true,
  },
};

function customScrollbars(selector, settings = {}) {
  $(selector).each(function (i, el) {
    $(el).mCustomScrollbar($.extend(defaultSettings, settings));
  });
}

export default customScrollbars;
